import {
  isPlainObject,
  isArray,
  camelCase,
  snakeCase
} from 'lodash'

function deepMapKeys (value, map) {
  if (isPlainObject(value)) {
    const obj = value
    const newObj = {}
    for (const [key, val] of Object.entries(obj)) {
      newObj[map(key)] = deepMapKeys(val, map)
    }
    return newObj
  } else if (isArray(value)) {
    const array = value
    return array.map(val => deepMapKeys(val, map))
  } else {
    return value
  }
}

function toCamelcase (value) {
  return deepMapKeys(value, key => camelCase(key))
}

function toSnakecase (value) {
  return deepMapKeys(value, key => snakeCase(key))
}

export {
  toCamelcase,
  toSnakecase
}
